import { render } from "./CoberturasOperarios.vue?vue&type=template&id=d9c86be2"
import script from "./CoberturasOperarios.vue?vue&type=script&lang=js"
export * from "./CoberturasOperarios.vue?vue&type=script&lang=js"

import "./CoberturasOperarios.vue?vue&type=style&index=0&id=d9c86be2&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__